import { useMutation } from "@tanstack/react-query";

import { requisitesApi } from "@shared/api";

import { useRequisitesQuery } from "./use-requisites-query";

interface UseEditRequisitesParams {
  id: string;
}

interface QueryData {
  xTOTP: string;
}

export const useDeleteRequisites = ({ id }: UseEditRequisitesParams) => {
  const { invalidateRequisites, removeById } = useRequisitesQuery();

  const { error, mutateAsync, isPending } = useMutation({
    mutationFn: (data: QueryData) =>
      requisitesApi.deleteApiV1BankAccountsId({
        id,
        xTOTP: data.xTOTP,
      }),
    onSettled: invalidateRequisites,
    onSuccess: async () => {
      removeById(id);
    },
  });

  return { deleteRequisites: mutateAsync, error, isPending };
};
